import React, { useState } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Box, AppBar, Toolbar, IconButton, Tooltip, Paper } from '@mui/material'
import { Switch, Link } from 'react-router-dom'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { AccountCircle } from '@mui/icons-material'
import Avatar from '@mui/material/Avatar'
import Logout from '@mui/icons-material/Logout'
import makeStyles from '@mui/styles/makeStyles'

import { Navbar } from '../Navbar'
import { userRoutes } from './RouteConfig'
import { PrivateRoute } from './PrivateRoute'

import { useIsAuthenticated } from '@azure/msal-react'

import { UserProfileView } from '../UserManagement/UserProfileView'
import { Logo } from './../Common/Logo'

const useStyles = makeStyles(() => ({
  appBar: {
    color: '#0A688D',
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },

  avatar: {
    color: '#0a688d',
    size: 18,
  },
  link: {
    textDecoration: 'none',
    color: '#0A688D',
    fontSize: '16px',
  },
  span: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))

export function RouterContainer({ handleLogout, name, role, user }): JSX.Element | null {
  const classes = useStyles()

  const isAzureAuthenticated = useIsAuthenticated()

  const routes = userRoutes[role]

  const [profileOpen, setProfileOpen] = useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const handleSettingsOpen = Boolean(anchorEl)

  const handleSettingsClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleSettingsClose = () => {
    setAnchorEl(null)
  }

  const handleProfile = (e) => {
    setAnchorEl(null)
    setProfileOpen(true)
  }

  const handleClose = (e) => {
    e.stopPropagation()
    setProfileOpen(false)
  }

  return (
    <Box sx={{ backgroundColor: '#fff' }}>
      <Router>
        <Box style={{ flexGrow: 1 }}>
          <AppBar position="static" sx={{ color: '#0A688D', backgroundColor: 'rgba(255, 255, 255, 1)' }}>
            <Toolbar>
              <div color="inherit" style={{ flexGrow: 1, padding: '8px' }}>
                <Link to="/" className={classes.link}>
                  <Logo width={'126'} height={'70'} />
                </Link>
              </div>
              {/* {role ? ( */}
              {name ? (
                <div style={{ display: 'flex' }}>
                  <span className={classes.span}>
                    {` ${name}`}
                    <sub>({role})</sub>
                  </span>
                  <Tooltip title="Account settings">
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={handleSettingsClick}
                      size="large"
                    >
                      <AccountCircle className={classes.avatar} />
                    </IconButton>
                  </Tooltip>
                  <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={handleSettingsOpen}
                    onClose={handleSettingsClose}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 1,
                        },
                        '&:before': {
                          content: '""',
                          display: 'block',
                          position: 'absolute',
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: 'background.paper',
                          transform: 'translateY(-50%) rotate(45deg)',
                          zIndex: 0,
                        },
                      },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  >
                    <MenuItem onClick={handleProfile}>
                      <Avatar />
                      My Profile
                      {profileOpen && (
                        <UserProfileView
                          user={user}
                          role={role}
                          handleClose={handleClose}
                          profileOpen={profileOpen}
                          setProfileOpen={setProfileOpen}
                        />
                      )}
                    </MenuItem>
                    <MenuItem onClick={handleLogout}>
                      <Logout style={{ marginRight: '5px' }} />
                      Logout
                    </MenuItem>
                  </Menu>
                </div>
              ) : null}
            </Toolbar>
          </AppBar>
          {role ? <Navbar role={role} user={user} /> : null}
        </Box>
        <Box sx={{ m: '6px auto 0 auto', p: '16px', maxWidth: '1440px' }}>
          <Paper elevation={3} sx={{ p: '24px' }}>
            {user ? (
              <Switch>
                {routes.map((route, i) => {
                  // if (route.path === '/login') {
                  //   return (
                  //     <Route key={i} exact={route.exact} path={route.path}>
                  //       <route.component authFailedMessage={authErrorMessage} user={user} role={role} />
                  //     </Route>
                  //   )
                  // }

                  return (
                    <PrivateRoute
                      key={i}
                      exact={route.exact}
                      path={route.path}
                      user={user}
                      role={role}
                      isAzureAuthenticated={isAzureAuthenticated}
                    >
                      <route.component user={user} role={role} />
                    </PrivateRoute>
                  )
                })}
              </Switch>
            ) : null}
          </Paper>
        </Box>
      </Router>
    </Box>
  )
}
